<script setup>
import {computed} from 'vue'
import {useFormStore} from '@/stores/form'
import vFormValidation from '@/vue/directives/formValidation'
import FormControlPlainText from "@/common/form-control/FormControlPlainText.vue"

const props = defineProps({
    formId: String,
    field: Object,
    currentData: Object,
})

// Pinia Store
const formStore = computed(() => props.formId ? useFormStore(props.formId) : null)

// Computed properties
const formSmall = computed(() => {
    return formStore.value?.formSmall
})

// Emulating the created hook logic
if (props.field.defaultValue) {
    formStore.value?.setDefaultValue({
        name: props.field.name,
        value: props.field.defaultValue
    })
}
</script>

<template>
    <FormControlPlainText v-if="field.readonly" :value="currentData[field.name]" :form-id="formId"/>
    <input v-else :id="field.id" v-model="currentData[field.name]" v-form-validation :max="field.max" :min="field.min"
           :name="field.name" :placeholder="field.placeholder || undefined" :required="field.required"
           :step="field.step" class="form-control w-auto"
           :class="{'is-invalid': field.error, 'form-control-sm': formSmall}" type="number">
</template>